/** @jsx jsx */
import { Children, memo } from "react";
import { jsx } from "theme-ui";
import { Grid } from "theme-ui";

var ShowtimeListing = function ShowtimeListing(_a) {
  var children = _a.children;
  var childrenArray = Children.toArray(children);
  return jsx(Grid, {
    gap: 2,
    columns: "repeat(auto-fill, minmax(144px, 1fr))"
  }, childrenArray.map(function (child, index) {
    return jsx("div", {
      key: index
    }, child);
  }));
};

export default memo(ShowtimeListing);